export default function getResource(label, vars=[]) {
    const resources = {
        new: 'New',
        value: 'value',
        colors: 'Colors',
        color: 'Color',
        quickLook: 'Quicklook',
        sponsored: 'Sponsored',
        regPrice: ' Reg. price',
        selectSaleItems: 'Select sale items',
        viewSimilarProducts: 'View similar products',
        purchased: 'PURCHASED',
        bestseller: 'BESTSELLER',
        buyItAgain: 'BUY IT AGAIN',
        percentageOff: `${vars[0]}% OFF`,
        percentageOffRange: `UP TO ${vars[0]}% OFF`
    };

    return resources[label];
}
